<template>
  <div class="select-special-conditions">
    <AppCheckbox
      v-for="(item, index) in changedList"
      :key="`select-special-conditions-${index}`"
      :label="item.label"
      :isChecked="item.checked"
      class="select-special-conditions__checkbox"
      @clicked="setList(item)"
    />
  </div>
</template>

<script>
import AppCheckbox from '@/components/elements/AppCheckbox'
export default {
  components: {
    AppCheckbox
  },
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      changedList: this.list
    }
  },
  watch: {
    list(newList) {
      this.changedList = newList
    }
  },
  methods: {
    setList(item) {
      this.changedList = this.changedList.map(d => {
        if (d.id === item.id) {
          return {
            ...d,
            checked: !item.checked
          }
        }
        return d
      })
      
      this.$emit('changed', this.changedList)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-special-conditions {

  &__checkbox {
    &:not(:last-child) {
      margin-bottom: .5rem;
    }
  }
}
</style>